module.exports = __webpack_public_path__ + "assets/tenBis-logo-b970ab.svg";